<template>
  <div class="container">
    <Layout :key="modulo" />
    <br>
    <Welcome v-model:show="showWelcome" v-if="modulo === 0 && showWelcome"/>
    <br>
<div class="card-container" v-if="modulo === 0">
  <div class="modulo-grid">
    <div class="card modulo-card" @click="modulo_seleccionado(1)" v-if="moduloAdministracion === 1">
      <img src="../assets/administracion.png" class="card-img-top modulo-img" alt="Administración">
      <div class="card-body">
        <h5 class="card-title text-center">Administración</h5>
      </div>
    </div>
    <div class="card modulo-card" @click="modulo_seleccionado(2)" v-if="moduloAtencion === 1">
      <img src="../assets/images/atenciones.png" class="card-img-top modulo-img" alt="Atenciones">
      <div class="card-body">
        <h5 class="card-title text-center">Atenciones Médicas</h5>
      </div>
    </div>
    <div class="card modulo-card" @click="modulo_seleccionado(3)" v-if="moduloFacturacion === 1">
      <img src="../assets/images/financiero.png" class="card-img-top modulo-img" alt="Financiero">
      <div class="card-body">
        <h5 class="card-title text-center">Financiero y Tributario</h5>
      </div>
    </div>
    <div class="card modulo-card" @click="modulo_seleccionado(4)" v-if="moduloDashboards === 1">
      <img src="../assets/images/dashboards.png" class="card-img-top modulo-img" alt="Dashboards">
      <div class="card-body">
        <h5 class="card-title text-center">Dashboards</h5>
      </div>
    </div>
  </div>
</div>
    <br>
    <tips v-if="modulo === 0"></tips>
    <div class="card-group" v-if="modulo === 1">
      <div>
        <img src="../assets/administracion.png" class="card-img-top" alt="..."
          style="width: 400px; height: 400px; object-fit: cover;">
        <div class="card-body">
          <h5 class="card-title">Administración</h5>
        </div>
      </div>
    </div>
<div class="modulo-grid" v-if="modulo === 2">
  <div v-for="opcion in opcionesAtenciones" :key="opcion.id"
    class="card modulo-card" @click="navegar(opcion.ruta)">
    <div class="modulo-img-wrap">
      <img :src="opcion.imagen" class="modulo-img" alt="">
    </div>
    <div class="card-body">
      <h5 class="card-title">{{ opcion.titulo }}</h5>
      <p class="card-text">{{ opcion.descripcion }}</p>
    </div>
  </div>
</div>

<div class="modulo-grid" v-if="modulo === 3">
  <div v-for="opcion in opcionesFinanciero" :key="opcion.id"
    class="card modulo-card" @click="navegar(opcion.ruta)">
    <div class="card-body">
      <h5 class="card-title">{{ opcion.titulo }}</h5>
      <p class="card-text">{{ opcion.descripcion }}</p>
    </div>
  </div>
</div>

<div class="modulo-grid" v-if="modulo === 4">
  <div v-for="opcion in opcionesDashboards" :key="opcion.id"
    class="card modulo-card" @click="navegar(opcion.ruta)">
    <div class="card-body">
      <h5 class="card-title">{{ opcion.titulo }}</h5>
      <p class="card-text">{{ opcion.descripcion }}</p>
    </div>
  </div>
</div>

<div class="modulo-grid" v-if="modulo === 5">
  <div v-for="opcion in opcionesAuditoria" :key="opcion.id"
    class="card modulo-card" @click="navegar(opcion.ruta)">
    <div class="card-body">
      <h5 class="card-title">{{ opcion.titulo }}</h5>
      <p class="card-text">{{ opcion.descripcion }}</p>
    </div>
  </div>
</div>
      <br><br><br><br>
    <div class="estilo-destacado" v-if="modulo != 0">
      Para explorar y acceder a las demás opciones del módulo, por favor utilice el menú lateral izquierdo.
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import Tips from '@/components/Tips.vue'
import Welcome from '@/components/Welcome.vue';

export default {
  data() {
    return {
      moduloAdministracion: 0,
      moduloAtencion: 0,
      moduloAuditoria: 0,
      moduloFacturacion: 0,
      moduloDashboards: 0,      
      usuario: '',
      modulo: 0,
      showWelcome: true,
      opcionesAtenciones: [
        {
          id: 1,
          titulo: 'Citas y Admisión',
          descripcion: 'Crear, programar y administrar citas médicas de los pacientes.',
          ruta: '/cita',
          imagen: require('@/assets/images/atenciones/citas.png')
        },
        {
          id: 2,
          titulo: 'Atenciones Médicas',
          descripcion: 'Registrar, consultar y dar seguimiento a las atenciones médicas.',
          ruta: '/atencion',
          imagen: require('@/assets/images/atenciones/atenciones.png')
        },
        {
          id: 3,
          titulo: 'Interconsultas',
          descripcion: 'Gestionar solicitudes de interconsulta entre médicos y especialidades.',
          ruta: '/interconsulta',
          imagen: require('@/assets/images/atenciones/interconsultas.png')
        }
      ],
      opcionesAuditoria: [
        {
          id: 1,
          titulo: 'Trámites',
          descripcion: 'Administrar y realizar seguimiento a los trámites médicos y administrativos.',
          ruta: '/tramite',
          imagen: require('@/assets/images/atenciones/citas.png')
        },
        {
          id: 2,
          titulo: 'Atenciones Auditadas',
          descripcion: 'Revisar y controlar las atenciones médicas para procesos de auditoría.',
          ruta: '/atencion',
          imagen: require('@/assets/images/atenciones/atenciones.png')
        },
        {
          id: 3,
          titulo: 'Interconsultas Auditadas',
          descripcion: 'Evaluar y dar seguimiento a las interconsultas registradas.',
          ruta: '/interconsulta',
          imagen: require('@/assets/images/atenciones/interconsultas.png')
        }
      ],
      opcionesFinanciero: [
        {
          id: 1,
          titulo: 'Facturación',
          descripcion: 'Generar y administrar la facturación de los servicios médicos.',
          ruta: '/atencionfacturacion'
        },
        {
          id: 2,
          titulo: 'Facturas Emitidas',
          descripcion: 'Consultar el historial y detalle de las facturas generadas.',
          ruta: '/factura'
        },
        {
          id: 3,
          titulo: 'Ingresos por Forma de Pago',
          descripcion: 'Visualizar ingresos agrupados según la forma de pago utilizada.',
          ruta: '/agrupados-por-forma-pago'
        },
        {
          id: 4,
          titulo: 'Ingresos por Asegurador',
          descripcion: 'Consultar ingresos agrupados por aseguradoras.',
          ruta: '/agrupados-por-asegurador'
        }
      ],
      opcionesDashboards: [
        {
          id: 1,
          titulo: 'Citas por Estado',
          descripcion: 'Visualizar el estado actual de las citas médicas.',
          ruta: '/citaspormedico'
        },
        {
          id: 2,
          titulo: 'Citas por Especialidad',
          descripcion: 'Analizar la distribución de citas por especialidad médica.',
          ruta: '/citasporespecialidad'
        },
        {
          id: 3,
          titulo: 'Citas por Médico',
          descripcion: 'Consultar estadísticas de citas asignadas a cada médico.',
          ruta: '/citaspormedico'
        }
      ]
    }
  },
  components: {
    Layout, Footer, Tips, Welcome
  },
  async mounted() {
    this.moduloAdministracion = parseInt(window.sessionStorage.getItem('moduloAdministracion'), 10) || 0;
    this.moduloAtencion = parseInt(window.sessionStorage.getItem('moduloAtencion'), 10) || 0;
    this.moduloAuditoria = parseInt(window.sessionStorage.getItem('moduloAuditoria'), 10) || 0;
    this.moduloFacturacion = parseInt(window.sessionStorage.getItem('moduloFacturacion'), 10) || 0;
    this.moduloDashboards = parseInt(window.sessionStorage.getItem('moduloDashboards'), 10) || 0;

    if(window.sessionStorage.getItem("bienvenida") == 1)
      this.showWelcome = true;
	else
      this.showWelcome = false;
    await this.authorization()
//    alert("Menú Principal - mounted: "+window.sessionStorage.getItem("modulo"));
  },
  methods: {
    navegar(ruta) {
      this.$router.push(ruta);
    },    
    async authorization() {
      this.usuario = window.sessionStorage.getItem("usuario");
    },
    async modulo_seleccionado(p_modulo) {
      this.modulo = p_modulo;      
//      alert("Menú Principal - modulo_seleccionado: "+this.modulo);
      window.sessionStorage.setItem('modulo', this.modulo);
      this.$router.push('/MenuPrincipal');
    }
  }
}
</script>
<style scoped>
/* Grid responsive para todos los módulos */
.modulo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

/* Card base */
.modulo-card {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  display: flex;
  flex-direction: column;
}
.modulo-card:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0 0 12px 3px rgb(253, 209, 13);
  transform: translateY(-5px);
}

/* Imagen */
.modulo-img-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
}
.modulo-img {
  width: 100%;
  max-width: 180px;
  height: 180px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

/* Card body */
.card-body {
  padding: 16px;
  background: linear-gradient(145deg, #ffffff, #f0f0f0);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.card-title {
  font-size: 18px;
  color: #0056b3;
  font-weight: 600;
  text-align: center;
}
.card-text {
  font-size: 14px;
  color: #555;
  text-align: center;
  margin: 0;
}

/* Aviso módulo activo */
.estilo-destacado {
  background-color: #4CAF50;
  color: white;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 16px;
  text-align: center;
  margin: 12px 0;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

/* Móvil: una columna */
@media (max-width: 480px) {
  .modulo-grid {
    grid-template-columns: 1fr;
    padding: 12px 0;
  }
  .card-title { font-size: 16px; }
  .card-text  { font-size: 13px; }
}
</style>
